const waitForInvocationReaction = require('../reactions_utils').waitForInvocationReaction;

module.exports = {
  utils : {
    waitForInvocationReaction
  }
};
